{
  "draft": {
    "restoreTitle": "¿Recuperar el borrador del {{date}}?",
    "restoreHint": "Este borrador aún no se ha enviado. Los adjuntos y las fotos no se guardan en él: vuelve a seleccionarlos si los necesitas.",
    "restore": "Recuperar",
    "discard": "Descartar",
    "saveFailed": "No se pudo guardar el borrador en este dispositivo.",
    "saveFailedHint": "Lo que escribiste sigue en pantalla, pero aún no se ha enviado."
  },
  "update": {
    "available": "Hay una actualización disponible. Puedes actualizar en cuanto termines.",
    "hintForm": "Intentaremos guardar tu borrador en este dispositivo antes. Los adjuntos aún no enviados deberán seleccionarse de nuevo.",
    "hintUpload": "Hay un envío en curso. Si actualizas ahora, se interrumpirá y el archivo deberá seleccionarse de nuevo.",
    "manual": "Hay una actualización disponible. La actualización automática no funcionó; toca Actualizar para intentarlo de nuevo.",
    "now": "Actualizar ahora",
    "manualButton": "Actualizar",
    "applying": "Actualizando…",
    "saveFailedBody": "No se pudo guardar el borrador en este dispositivo. Si actualizas ahora, lo que escribiste se perderá.",
    "anyway": "Actualizar de todos modos",
    "keepEditing": "Seguir editando",
    "chunkFailed": "No se pudo cargar esta parte de la app. Revisa tu conexión e inténtalo de nuevo.",
    "retry": "Intentar de nuevo"
  },
  "install": {
    "title": "Instalar Lumora",
    "intro": "Puedes añadir Lumora a la pantalla de inicio para abrirla como una app. Funciona principalmente en línea: no se puede usar por completo sin internet.",
    "installed": "Ya estás usando Lumora como app instalada.",
    "iphone": {
      "title": "iPhone (Safari)",
      "step1": "Abre Lumora en Safari.",
      "step2": "Toca Compartir.",
      "step3": "Elige Añadir a pantalla de inicio.",
      "step4": "Toca Añadir."
    },
    "android": {
      "title": "Android (Chrome)",
      "step1": "Abre Lumora en Chrome.",
      "step2": "Abre el menú (tres puntos).",
      "step3": "Toca Instalar app o Añadir a la pantalla de inicio.",
      "step4": "Confirma."
    },
    "desktop": {
      "title": "Ordenador (Chrome o Edge)",
      "step1": "Abre Lumora en el navegador.",
      "step2": "Haz clic en el icono de instalar de la barra de direcciones, o abre el menú y elige Instalar Lumora.",
      "step3": "Confirma."
    },
    "note": "Cuando haya una versión nueva, Lumora te avisa y actualiza cuando sea seguro. Si la app instalada parece desactualizada, ciérrala y ábrela de nuevo."
  },
  "forms": {
    "warrantyReminderHint": "Si lo marcas, el aviso 30 días antes del fin de la garantía declarada queda activo. Solo avisamos según la fecha que declaraste."
  }
}
